export enum DashboardTypes {
    my = 1,
    team,
    wallboard
}
